import React, { useState } from "react";
import styles from "./AdminPanel.module.css";
import UsersTab from "./tabs/UsersTab";
import MembersTab from "./tabs/MembersTab";
import ApprovalsTab from "./tabs/ApprovalsTab";
import LeadershipTab from "./tabs/LeadershipTab";
import RecognitionTab from "./tabs/RecognitionTab";
import StatsTab from "./tabs/StatsTab";

export default function AdminPanel() {
  const [tab, setTab] = useState("users");

  const tabs = [
    { key: "stats", label: "Stats" },
    { key: "members", label: "Members" },
    { key: "leadership", label: "Leadership Roles" },
    { key: "recognition", label: "Recognition" },
  ];

  return (
    <div className={styles.wrapper}>
      <h1 className={styles.heading}>Admin Panel</h1>

      {/* ✅ TAB BUTTONS */}
      <div className={styles.tabs}>
        {tabs.map((t) => (
          <button
            key={t.key}
            onClick={() => setTab(t.key)}
            className={`${styles.tabBtn} ${tab === t.key ? styles.active : ""}`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {/* ✅ TAB CONTENT */}
      <div className={styles.content}>
        {tab === "users" && <UsersTab />}

        {tab === "members" && <MembersTab />}
        {tab === "approvals" && <ApprovalsTab />}
        {tab === "leadership" && <LeadershipTab />}
        {tab === "recognition" && <RecognitionTab />}
        {tab === "stats" && <StatsTab />}
      </div>
    </div>
  );
}
